<template>
    <Modal
        :visible="visible"
        :buttonText="buttonText"
        :buttonSize="buttonSize"
        :buttonDisabled="disablePlanVisitBtn"
        ref="modalPlanVisit"
        v-if="this.$page.props.user.permissions.includes('requests.planvisit')"
    >
        <div>
            <Form @submitted="postPlanVisit">
                <h3>Bezoek inplannen</h3>
                <Input
                    type="date"
                    label="Geplande datum"
                    name="planned_at"
                    :required="true"
                    v-model="formPlanVisit.planned_at"
                    :error="formPlanVisit.errors.planned_at"
                    layout="vertical"
                />
                <div class="flex">
                    <Input
                        type="time"
                        label="Starttijd"
                        name="start_time"
                        :step="900"
                        v-model="formPlanVisit.start_time"
                        :error="formPlanVisit.errors.start_time"
                        layout="vertical"
                        class="w-1/2 mr-1"
                    />
                    <Input
                        type="time"
                        label="Eindtijd"
                        name="end_time"
                        :step="900"
                        v-model="formPlanVisit.end_time"
                        :error="formPlanVisit.errors.end_time"
                        layout="vertical"
                        class="w-1/2 ml-1"
                    />
                </div>
                <Select
                    label="ADI"
                    name="executor"
                    :required="true"
                    :options="executorOptions"
                    v-model="formPlanVisit.executor"
                    :error="formPlanVisit.errors.executor"
                    layout="vertical"
                />
                <Input
                    label="Ophalen sleutel"
                    name="key"
                    id="key"
                    type="checkbox"
                    :checked="Boolean(formPlanVisit.key)"
                    value="1"
                    v-model="formPlanVisit.key"
                    :error="formPlanVisit.errors.key"
                />
                <Textarea
                    label="Adres sleutel"
                    name="key_address"
                    :disabled="!formPlanVisit.key"
                    v-model="formPlanVisit.key_address"
                    :error="formPlanVisit.errors.key_address"
                    layout="vertical"
                />
                <Textarea
                    label="Extra info"
                    name="info"
                    v-model="formPlanVisit.info"
                    :error="formPlanVisit.errors.info"
                    layout="vertical"
                />
                <Input
                    label="Contact persoon"
                    name="contact_person"
                    type="text"
                    v-model="formPlanVisit.contact_person"
                    :error="formPlanVisit.errors.contact_person"
                    layout="vertical"
                />
                <Button
                    text="Opslaan"
                    buttonClass="save"
                    type="submit"
                    :loading="formPlanVisit.processing"
                    class="self-end"
                />
            </Form>
        </div>
    </Modal>
</template>

<script>
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'
import Textarea from '@/Components/Textarea.vue'

import {ref, watch, onMounted} from "vue";
import {useForm} from "@inertiajs/inertia-vue3";

import store from '@/store'
import moment from "moment/moment";

export default {
    components: {
        Button,
        Modal,
        Form,
        Input,
        Select,
        Textarea,
    },
    props: {
        request: {
            required: true
        },
        requestTypeOptions: {
            requestTypeOptions: true
        },
        executorOptions: {
            required: true
        },
        buttonText: {
            required: false,
            default: 'Bezoek inplannen',
        },
        buttonSize: {
            required: false,
            default: 'default',
        },
        disablePlanVisitBtn: {
            required: false,
            type: Boolean,
            default: (props) => props.request && (props.request.visits && props.request.visits.length > 0
                || ['awaiting_approval', 'planned', 'in_progress', 'reported', 'invoiced'].includes(props.request.status)
                || (props.requestTypeOptions[props.request.request_type_id].includes('Offerte') && props.request.approved != 1)
            )
        },
        replanVisit: {
            required: false,
            default: false,
        },
        visitToReplan: {
            required: false,
            default: null
        },
        extraVisit: {
            required: false,
            default: false,
        },
        visible: {
            type: String,
            default: "all"
        },
    },
    emits: ['visitReplanned', 'update:visitToReplan'],
    setup(props, { emit })
    {
        let modalPlanVisit = ref(null)

        const formPlanVisit = useForm({
            request_id: (props.request) ? props.request.id : null,
            visit_id: null,
            planned_at: null,
            start_time: null,
            end_time: null,
            executor: null,
            key: false,
            key_address: null,
            info: null,
            contact_person: null,
        })

        function replanVisit()
        {
            formPlanVisit.request_id = props.request.id
            formPlanVisit.visit_id = props.visitToReplan.id ?? null
            formPlanVisit.planned_at = props.visitToReplan.planned_at ?? null
            formPlanVisit.start_time = props.visitToReplan.start_time ?? null
            formPlanVisit.end_time = props.visitToReplan.end_time ?? null
            formPlanVisit.executor = props.visitToReplan.executor ?? null
            formPlanVisit.key = props.visitToReplan.key ?? null
            formPlanVisit.key_address = props.visitToReplan.key_address ?? null
            formPlanVisit.info = props.visitToReplan.info ?? null
            formPlanVisit.contact_person = props.visitToReplan.contact_person ?? null

            modalPlanVisit.value.show = true

            // emit('update:visitToReplan', props.visitToReplan)
        }

        function extraVisit()
        {
            formPlanVisit.reset()
            formPlanVisit.request_id = props.request.id
            formPlanVisit.visit_id = null
            formPlanVisit.planned_at = null
            formPlanVisit.start_time = null
            formPlanVisit.end_time = null
            formPlanVisit.executor = null
            formPlanVisit.key = false
            formPlanVisit.key_address = null
            formPlanVisit.info = null
            formPlanVisit.contact_person = null

            modalPlanVisit.value.show = true
        }

        function postPlanVisit()
        {
            formPlanVisit.post(route('requests.plan-visit'), {
                onSuccess: () => {
                    formPlanVisit.reset()
                    modalPlanVisit.value.show = false
                },
            })
        }

        watch(() => props.replanVisit, (replanVisitVal) => {

            //Check if replanVisit event is triggered in the parent
            if (replanVisitVal)
            {
                replanVisit()
            }
        })

        watch(() => props.extraVisit, (extraVisitVal) => {

            //Check if extraVisit event is triggered in the parent
            if (extraVisitVal)
            {
                extraVisit()
            }
        })

        onMounted(() => {
            //Check if modal gets closed, even if only close button is used
            watch(() => modalPlanVisit.value.show, (modalShow, prevModalShow) => {
                if (!modalShow) {
                    emit('visitReplanned')
                }
            })
        })

        return {
            state: store.state,
            ...store,
            modalPlanVisit,
            formPlanVisit,
            postPlanVisit,
        }
    },
    created: function () {
        this.moment = moment;
    },
}
</script>
